import { render, staticRenderFns } from "./relatedProducts.vue?vue&type=template&id=090501cf&scoped=true"
import script from "./relatedProducts.vue?vue&type=script&lang=js"
export * from "./relatedProducts.vue?vue&type=script&lang=js"
import style0 from "./relatedProducts.vue?vue&type=style&index=0&id=090501cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090501cf",
  null
  
)

export default component.exports